import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { colorYellow, colorYellowDark } from 'styles/layout/colors';
import useRandomId from 'hooks/useRandomId';
const IconStar = t0 => {
  const $ = _c(24);
  const {
    className: t1,
    fill: t2,
    height: t3,
    stroke: t4,
    width: t5,
    offsetValue: t6,
    onPointerEnter,
    onPointerLeave
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const fill = t2 === undefined ? colorYellow : t2;
  const height = t3 === undefined ? 16 : t3;
  const stroke = t4 === undefined ? colorYellowDark : t4;
  const width = t5 === undefined ? 16 : t5;
  const offsetValue = t6 === undefined ? 0 : t6;
  const svgId = useRandomId("star-gradient-");
  let t7;
  if ($[0] !== fill) {
    t7 = <stop offset="0%" stopColor={fill} />;
    $[0] = fill;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const t8 = `${offsetValue * 100}%`;
  let t9;
  if ($[2] !== fill || $[3] !== t8) {
    t9 = <stop offset={t8} stopColor={fill} />;
    $[2] = fill;
    $[3] = t8;
    $[4] = t9;
  } else {
    t9 = $[4];
  }
  const t10 = `${offsetValue * 100}%`;
  let t11;
  if ($[5] !== t10) {
    t11 = <stop offset={t10} stopColor="white" />;
    $[5] = t10;
    $[6] = t11;
  } else {
    t11 = $[6];
  }
  let t12;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <stop offset="100%" stopColor="white" />;
    $[7] = t12;
  } else {
    t12 = $[7];
  }
  let t13;
  if ($[8] !== svgId || $[9] !== t11 || $[10] !== t7 || $[11] !== t9) {
    t13 = <defs><linearGradient id={svgId}>{t7}{t9}{t11}{t12}</linearGradient></defs>;
    $[8] = svgId;
    $[9] = t11;
    $[10] = t7;
    $[11] = t9;
    $[12] = t13;
  } else {
    t13 = $[12];
  }
  const t14 = `url('#${svgId}')`;
  let t15;
  if ($[13] !== stroke || $[14] !== t14) {
    t15 = <path d="M9.945 4.62l-.018-.039L8.435.768C8.264.378 7.793.362 7.68.67L6.077 4.532c-.27.547-.692.902-1.197.9l-3.964.356c-.424.042-.573.58-.241.916l2.928 2.69c.385.389.526.923.398 1.44l-.88 4c-.091.459.318.76.656.547l3.425-2.128c.434-.292 1.096-.292 1.514-.01l3.443 2.14c.336.212.745-.09.656-.539l-.879-3.998a1.52 1.52 0 01.412-1.468l3.01-2.773c.282-.244.112-.777-.235-.816l-4.059-.282c-.511-.129-.884-.411-1.12-.886z" stroke={stroke} fill={t14} fillRule="nonzero" />;
    $[13] = stroke;
    $[14] = t14;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] !== className || $[17] !== height || $[18] !== onPointerEnter || $[19] !== onPointerLeave || $[20] !== t13 || $[21] !== t15 || $[22] !== width) {
    t16 = <svg width={width} height={height} viewBox="0 0 16 16" className={className} onPointerEnter={onPointerEnter} onPointerLeave={onPointerLeave}>{t13}{t15}</svg>;
    $[16] = className;
    $[17] = height;
    $[18] = onPointerEnter;
    $[19] = onPointerLeave;
    $[20] = t13;
    $[21] = t15;
    $[22] = width;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  return t16;
};
IconStar.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  height: PropTypes.number,
  stroke: PropTypes.string,
  width: PropTypes.number,
  offsetValue: PropTypes.number,
  onPointerEnter: PropTypes.func,
  onPointerLeave: PropTypes.func
};
export default IconStar;